var MemoryStorage = /** @class */ (function () {
    function MemoryStorage() {
        this.storage = {};
    }
    MemoryStorage.prototype.getItem = function (key) {
        return this.storage[key] || null;
    };
    MemoryStorage.prototype.setItem = function (key, value) {
        if (typeof value !== 'string') {
            throw new Error("[MemoryStorage] value must be from a type of 'string' got '" + typeof value + "'");
        }
        this.storage[key] = value;
    };
    MemoryStorage.prototype.clear = function () {
        this.storage = {};
    };
    MemoryStorage.prototype.removeItem = function (key) {
        if (this.storage.hasOwnProperty(key)) {
            // tslint:disable-next-line: no-dynamic-delete
            delete this.storage[key];
        }
    };
    return MemoryStorage;
}());
export { MemoryStorage };
export var aMemoryStorage = new MemoryStorage();
//# sourceMappingURL=memoryStorage.js.map